// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepOne-module__infoBox--c28aU {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  align-items: center;
}

.StepOne-module__leftBox--uxG0j {
  display: flex;
  flex-direction: column;
  width: 60%;
}

.StepOne-module__info--oaJBv > h4 {
  color: var(--color-primary);
  font-weight: 500;
  display: flex;
  text-transform: uppercase;
  margin: 10px 0;
}

.StepOne-module__info--oaJBv > p {
  font-weight: 400;
  font-size: 16px;
}

.StepOne-module__info--oaJBv > p > span {
  text-transform: lowercase;
}

.StepOne-module__risksList--w4yR5 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.StepOne-module__riskBox--omnUM {
  display: flex;
  gap: 10px;
  align-items: center;
}

.StepOne-module__riskBox--omnUM > p {
  margin: 0;
  background-color: rgb(43 93 235 / 5%);
  padding: 3px;
}

.StepOne-module__conditionsBox--t5zTz {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  flex-wrap: wrap;
}
.StepOne-module__conditionsItem--BTVnL {
  padding: 10px;
  border-radius: 14px;
  border: 1px solid rgb(43 93 235 / 13%);
  width: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.StepOne-module__conditionsIcon--N0BEa {
  background-color: rgb(43 93 235 / 5%);
  border-radius: 50%;
  display: flex;
  height: 60px;
  width: 60px;
  justify-content: center;
  align-items: center;
}
.StepOne-module__conditionsIcon--N0BEa > svg {
  color: var(--color-primary);
  height: 30px;
  width: 30px;
}
.StepOne-module__conditionsItem--BTVnL > p {
  color: var(--color-text-item-column);
  font-size: 13px;
}

.StepOne-module__discription--bG7E1 {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-primary);
  font-weight: 500;
  font-size: 16px;
}
.StepOne-module__discription--bG7E1 > svg {
  height: 16px;
  width: 16px;
}
.StepOne-module__discriptionInfo--PE84C {
  color: var(--color-text-item-column);
  font-size: 13px;
  font-weight: 500;
}

.StepOne-module__checkIcon--XsIQO > svg {
  display: flex;
  align-items: center;
  height: 20px;
  color: var(--color-primary);
}

.StepOne-module__infoIcon--UYk3Q > svg {
  display: flex;
  align-items: center;
  height: 16px;
  color: var(--color-text-item-column);
}

.StepOne-module__risksList--w4yR5 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.StepOne-module__riskBox--omnUM {
  display: flex;
  gap: 10px;
  align-items: center;
}

.StepOne-module__riskBox--omnUM > p {
  margin: 0;
  background-color: rgb(43 93 235 / 5%);
  padding: 3px;
}

.StepOne-module__risksList--w4yR5 > h4,
.StepOne-module__conditionsContainer--bYHqK > h4 {
  color: var(--color-primary);
  text-transform: uppercase;
  font-weight: 500;
  margin: 10px 0;
}

.StepOne-module__colorBox--fv4aa > p > span {
  font-weight: bold;
  color: var(--color-primary);
}

.StepOne-module__colorBox--fv4aa {
  margin: 20px 0;
  display: flex;
  gap: 10px;
  align-content: center;
  justify-content: center;
  align-items: center;
  background-color: rgb(43 93 235 / 5%);
  border-radius: 20px;
  padding: 5px;
  font-size: 14px;
}

.StepOne-module__flexBox--qnnEm {
  display: flex;
  gap: 30px;
  height: 40px;
}

.StepOne-module__colorBox--fv4aa > p {
  margin: 0;
}

.StepOne-module__icon--UID4o > svg {
  color: var(--color-primary);
  font-size: 25px;
}

.StepOne-module__btnBox--O02En {
  display: flex;
  justify-content: flex-end;
}

.StepOne-module__desktopContainer--TV59a {
  padding: 10px;
}

.StepOne-module__rightBoxImg--_BQP4 {
  display: flex;
  flex-direction: column;
  width: 40%;
}

.StepOne-module__riskTitle--CnKkj {
  background-color: rgb(43 93 235 / 5%);
  padding: 3px;
  text-align: center;
  color: var(--color-primary);
}

.StepOne-module__info--oaJBv > h4 > span {
  display: flex;
  align-items: center;
  /* height: 16px; */
  color: var(--color-text-item-column);
}

.StepOne-module__info--oaJBv > h4 > span > svg {
  height: 16px;
  display: flex;
  align-items: center;
}

.StepOne-module__modalDesc--HZ916 > h4 {
  background-color: rgb(43 93 235 / 5%);
  padding: 3px;
  text-align: center;
  color: var(--color-primary);
}

.StepOne-module__modalDesc--HZ916 > p > span {
  color: var(--color-primary);
}

@media (max-width: 950px) {
  .StepOne-module__infoBox--c28aU {
    flex-direction: column;
  }

  .StepOne-module__leftBox--uxG0j,
  .StepOne-module__rightBox--XbE_3 {
    width: 100%;
  }

  .StepOne-module__formBox--vXiF5 {
    width: 80%;
  }

  .StepOne-module__rightBoxImg--_BQP4 {
    display: none;
  }
}

@media (max-width: 600px) {
  .StepOne-module__flexBox--qnnEm {
    flex-direction: column;
  }

  .StepOne-module__formBox--vXiF5 {
    width: 90%;
  }

  .StepOne-module__colorBox--fv4aa {
    width: 100%;
  }
  .StepOne-module__conditionsBox--t5zTz {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/health-ai/step-1/StepOne.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,YAAY;EACZ,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".infoBox {\r\n  display: flex;\r\n  gap: 20px;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.leftBox {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 60%;\r\n}\r\n\r\n.info > h4 {\r\n  color: var(--color-primary);\r\n  font-weight: 500;\r\n  display: flex;\r\n  text-transform: uppercase;\r\n  margin: 10px 0;\r\n}\r\n\r\n.info > p {\r\n  font-weight: 400;\r\n  font-size: 16px;\r\n}\r\n\r\n.info > p > span {\r\n  text-transform: lowercase;\r\n}\r\n\r\n.risksList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.riskBox {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.riskBox > p {\r\n  margin: 0;\r\n  background-color: rgb(43 93 235 / 5%);\r\n  padding: 3px;\r\n}\r\n\r\n.conditionsBox {\r\n  display: flex;\r\n  gap: 20px;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n}\r\n.conditionsItem {\r\n  padding: 10px;\r\n  border-radius: 14px;\r\n  border: 1px solid rgb(43 93 235 / 13%);\r\n  width: 180px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n.conditionsIcon {\r\n  background-color: rgb(43 93 235 / 5%);\r\n  border-radius: 50%;\r\n  display: flex;\r\n  height: 60px;\r\n  width: 60px;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.conditionsIcon > svg {\r\n  color: var(--color-primary);\r\n  height: 30px;\r\n  width: 30px;\r\n}\r\n.conditionsItem > p {\r\n  color: var(--color-text-item-column);\r\n  font-size: 13px;\r\n}\r\n\r\n.discription {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--color-primary);\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n}\r\n.discription > svg {\r\n  height: 16px;\r\n  width: 16px;\r\n}\r\n.discriptionInfo {\r\n  color: var(--color-text-item-column);\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n}\r\n\r\n.checkIcon > svg {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 20px;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.infoIcon > svg {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 16px;\r\n  color: var(--color-text-item-column);\r\n}\r\n\r\n.risksList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.riskBox {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n}\r\n\r\n.riskBox > p {\r\n  margin: 0;\r\n  background-color: rgb(43 93 235 / 5%);\r\n  padding: 3px;\r\n}\r\n\r\n.risksList > h4,\r\n.conditionsContainer > h4 {\r\n  color: var(--color-primary);\r\n  text-transform: uppercase;\r\n  font-weight: 500;\r\n  margin: 10px 0;\r\n}\r\n\r\n.colorBox > p > span {\r\n  font-weight: bold;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.colorBox {\r\n  margin: 20px 0;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-content: center;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: rgb(43 93 235 / 5%);\r\n  border-radius: 20px;\r\n  padding: 5px;\r\n  font-size: 14px;\r\n}\r\n\r\n.flexBox {\r\n  display: flex;\r\n  gap: 30px;\r\n  height: 40px;\r\n}\r\n\r\n.colorBox > p {\r\n  margin: 0;\r\n}\r\n\r\n.icon > svg {\r\n  color: var(--color-primary);\r\n  font-size: 25px;\r\n}\r\n\r\n.btnBox {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.desktopContainer {\r\n  padding: 10px;\r\n}\r\n\r\n.rightBoxImg {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 40%;\r\n}\r\n\r\n.riskTitle {\r\n  background-color: rgb(43 93 235 / 5%);\r\n  padding: 3px;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.info > h4 > span {\r\n  display: flex;\r\n  align-items: center;\r\n  /* height: 16px; */\r\n  color: var(--color-text-item-column);\r\n}\r\n\r\n.info > h4 > span > svg {\r\n  height: 16px;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.modalDesc > h4 {\r\n  background-color: rgb(43 93 235 / 5%);\r\n  padding: 3px;\r\n  text-align: center;\r\n  color: var(--color-primary);\r\n}\r\n\r\n.modalDesc > p > span {\r\n  color: var(--color-primary);\r\n}\r\n\r\n@media (max-width: 950px) {\r\n  .infoBox {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .leftBox,\r\n  .rightBox {\r\n    width: 100%;\r\n  }\r\n\r\n  .formBox {\r\n    width: 80%;\r\n  }\r\n\r\n  .rightBoxImg {\r\n    display: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .flexBox {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .formBox {\r\n    width: 90%;\r\n  }\r\n\r\n  .colorBox {\r\n    width: 100%;\r\n  }\r\n  .conditionsBox {\r\n    justify-content: center;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoBox": `StepOne-module__infoBox--c28aU`,
	"leftBox": `StepOne-module__leftBox--uxG0j`,
	"info": `StepOne-module__info--oaJBv`,
	"risksList": `StepOne-module__risksList--w4yR5`,
	"riskBox": `StepOne-module__riskBox--omnUM`,
	"conditionsBox": `StepOne-module__conditionsBox--t5zTz`,
	"conditionsItem": `StepOne-module__conditionsItem--BTVnL`,
	"conditionsIcon": `StepOne-module__conditionsIcon--N0BEa`,
	"discription": `StepOne-module__discription--bG7E1`,
	"discriptionInfo": `StepOne-module__discriptionInfo--PE84C`,
	"checkIcon": `StepOne-module__checkIcon--XsIQO`,
	"infoIcon": `StepOne-module__infoIcon--UYk3Q`,
	"conditionsContainer": `StepOne-module__conditionsContainer--bYHqK`,
	"colorBox": `StepOne-module__colorBox--fv4aa`,
	"flexBox": `StepOne-module__flexBox--qnnEm`,
	"icon": `StepOne-module__icon--UID4o`,
	"btnBox": `StepOne-module__btnBox--O02En`,
	"desktopContainer": `StepOne-module__desktopContainer--TV59a`,
	"rightBoxImg": `StepOne-module__rightBoxImg--_BQP4`,
	"riskTitle": `StepOne-module__riskTitle--CnKkj`,
	"modalDesc": `StepOne-module__modalDesc--HZ916`,
	"rightBox": `StepOne-module__rightBox--XbE_3`,
	"formBox": `StepOne-module__formBox--vXiF5`
};
export default ___CSS_LOADER_EXPORT___;
